import useScrollTop from "../../hooks/use-scroll-top";
import {ReactComponent as ArrowUp} from '../../assets/svgs/keyboard-double-up.svg';
const ScrollToTop = () => {
    const { stick, onClickHandler } = useScrollTop();
    if (stick) {
        return (
            <button
                aria-label="Scroll to top"
                type="button"
                className="scroll-top"
                onClick={onClickHandler}
            >
                <ArrowUp fill="white"/>
                {/* <i className="fa fa-angle-double-up"></i> */}
            </button>
        );
    }
    return null;
};

export default ScrollToTop;